import { Paper, Typography, Box, Modal } from "@mui/material";
import TableMuiCustom from "../mui/TableMuiCustom";
import { styled } from '@mui/system';
import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { selectnodess } from "../redux/nodesSlice";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    overflow: "auto", // Ensure no scrollbars appear on the outer box
    maxHeight: "90vh",
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
}));

export function DeleteNodeChildModel({
   
    handleClose,
    open,
    setNodeData,
    setdatafordelete,
    setOpenDeleteModal,
    setOpen,
    
    node
}) {
    const allorganization = useSelector(selectnodess);
    const closeModel = () => {
        handleClose(false)
    }
    //// console.log(node, "nodedata");
    //// console.log(allorganization, "allorg");

    const [data, setData] = useState([])

    useEffect(() => {
        // Find the node with node.nodeId
        const shareHolderNode = Array.isArray(allorganization) && allorganization.find((item) => item.id === node.nodeId);

        //// console.log(shareHolderNode, "shareHolderNode");

        if (shareHolderNode && Array.isArray(shareHolderNode.children)) {
            // Extract children IDs
            //// console.log(shareHolderNode.children);
            const childrenIds = shareHolderNode.children?.map(child => child._id.toString());

            //// console.log(childrenIds, "childrenIds");

            // Filter organizations by children IDs
            const filteredOrganizations = Array.isArray(allorganization) && allorganization.filter(organization =>
                childrenIds.includes(organization.id)
            );

            //// console.log(filteredOrganizations, "filteredOrganizations");
            setdatafordelete(filteredOrganizations)

            // Further filter organizations with shareHolders length greater than 1
            const finalFilteredOrganizations = filteredOrganizations.filter((item) =>
                item.data.shareHolders.length > 1
            );
          

            //// console.log(finalFilteredOrganizations, "finalFilteredOrganizations");

            const findnode=finalFilteredOrganizations.filter(org =>
                org.data.shareHolders.some(shareHolder => shareHolder.childId === node.nodeId)
            );

            if(findnode.length===0){
                setOpenDeleteModal(true)
                handleClose(false)

            }

            setData(findnode?.map((org, index) => ({
                ...org,
                data: {
                    ...org.data,
                    index: index + 1,

                    directors: org.data.directors ? org.data.directors.join(",") : "",
                    directorsLength: org.data.directors ? org.data.directors.length : 0,
                    shareHoldersLength: org.data.shareHolders ? org.data.shareHolders.length : 0,
                    // PercentageOfShares: org.PercentageOfShares.toFixed(1),
                },
            })))
} else {
    // console.log("shareHolderNode does not have children array or it's not an array");
}
    
 }, [allorganization, node]);






return (
    <React.Fragment>
        <Modal
            open={open}
            onClose={closeModel}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box sx={style}>

                <Typography variant="body1" className="text-center" id="child-modal-description" gutterBottom>
                    Please complete the shareholders' information for the companies holding shares in the company you want to delete.
                </Typography>
              { data && data.length>0? <TableMuiCustom
                    styleTableTh={{ fontWeight: "bold" }}
                    styleTableContainer={{ minWidth: "800px" }}
                    TableHead={{
                        borderRadius: "10px",
                        color: "black",
                        fontWeight: "bold",
                    }}
                    styleTableThead={{
                        backgroundColor: "white",
                        color: "black",
                        fontWeight: "bold",
                    }}
                    th={{
                        companyName: "Company Name",
                        totalNoOfShares: "Total Issued Shares",
                        shareHoldersLength: "Shareholders",
                        editBtn: "Edit",
                    }}
                    td={data}
                    customFields={[
                        {
                            name: "editBtn",
                            data: (value, row) => (
                                <Box className="d-flex justify-content-between align-items-center">
                                    <button
                                        onClick={() => {
                                            setOpen(true)
                                            handleClose(false)
                                            //// console.log(row, "rw");
                                            setNodeData({
                                                ...row,
                                                shareHolders: row.shareHolders || [
                                                    {
                                                        parentId: "",
                                                        totalNoOfShares: "",
                                                        PercentageOfShares: 0,
                                                    },
                                                ],
                                                directors: row.directors.split(",") || [],
                                            }); // Set the node data to the current row's data
                                           
                                        }
                                    }
                                        style={{ backgroundColor: "#003B93", color: "white" }}
                                        className="btn"
                                    >
                                        Edit
                                    </button>
                                </Box>
                            ),
                        }
                    ]}
                />:""}
            </Box>
        </Modal>
    </React.Fragment>
);
}
